module.exports = new __parcel__URL__("report-recently-created-issues.6436ced2.svg").toString();